module.exports = __webpack_public_path__ + "img/help-me-to-choose.4b639272.png";